const crops: any = {
    crops: {
        "1": "Watermeloen",
        "2": "Pompoen zomerpompoen",
        "3": "Courgette",
        "4": "Suikerriet",
        "5": "Augurk",
        "6": "Appel",
        "7": "Selderij",
        "8": "Abrikoos",
        "9": "Groene selderij herfst",
        "10": "Bieslook - 1ste jr",
        "11": "Bieslook - 2de jr",
        "12": "Wortelen gewassen",
        "13": "Zoete aardappel",
        "14": "Maïs (kuilvoer 67% water)",
        "15": "Perzik",
        "16": "Aardappel",
        "17": "Bosui",
        "18": "Knoflook",
        "19": "Boerenkool krulkool",
        "20": "Aardbei",
        "21": "Rode biet",
        "22": "Broccoli",
        "23": "Spruit",
        "24": "Bleekselderij herfst",
        "25": "Suikerbiet",
        "26": "Winterwortel",
        "27": "Tomaat",
        "28": "Winterui",
        "29": "Druif (tafel)",
        "30": "Sla - krop zomer",
        "31": "Peterselie",
        "32": "Sla - eikenblad zomer",
        "33": "Eikenbladsla",
        "34": "Topinamboer Aardpeer",
        "35": "Pruim",
        "36": "Cantaloupe",
        "37": "Oliepalm",
        "38": "Sla",
        "39": "Kiwi",
        "40": "Kool rood",
        "41": "Peer",
        "42": "Banaan",
        "43": "Andijvie escarole - zomer",
        "44": "Andijvie escarole - baby",
        "45": "Krulandijvie",
        "46": "Kool - gewone opslag",
        "47": "Prei - zomer",
        "48": "Prei - herfst winter",
        "49": "Aardbei doorlopende vruchtzetting",
        "50": "Papaya",
        "51": "Spinazie",
        "52": "Tomatenverwerking",
        "53": "Squash",
        "54": "Cichorei",
        "55": "Kool",
        "56": "Aubergine",
        "57": "Kool - lente",
        "58": "Savooiekool",
        "59": "Groene savooiekool",
        "60": "Gewone boon",
        "61": "Sinaasappel",
        "62": "Rode sjalot",
        "63": "Meloen",
        "64": "Tabak (flue)",
        "65": "Tabak (Burley)",
        "66": "Koffie",
        "67": "Gerst (lente)",
        "68": "Tarwe 10% proteïne",
        "69": "Tarwe 12% proteïne",
        "70": "Tarwe 14% proteïne",
        "71": "Maïs (graan)",
        "72": "Zonnebloem",
        "73": "Rijst",
        "74": "Sorghum (graan)",
    },
};
export default crops;
